const buildMobileImageSrcset = (href: string) => [
  `${href.replace('_WxH', `_375x300`)} 1x`,
  `${href.replace('_WxH', `_750x600`)} 2x`,
  `${href.replace('_WxH', `_1500x1200`)} 4x`,
];

const buildTabletImageSrcset = (href: string) => [
  `${href.replace('_WxH', `_320x320`)} 320w`,
  `${href.replace('_WxH', `_480x480`)} 480w`,
  `${href.replace('_WxH', `_640x640`)} 640w`,
  `${href.replace('_WxH', `_960x960`)} 960w`,
];

const buildDesktopImageSrcset = (href: string) => [
  `${href.replace('_WxH', `_320x192`)} 320w`,
  `${href.replace('_WxH', `_480x288`)} 480w`,
  `${href.replace('_WxH', `_640x384`)} 640w`,
  `${href.replace('_WxH', `_960x576`)} 960w`,
];

export {
  buildMobileImageSrcset,
  buildTabletImageSrcset,
  buildDesktopImageSrcset,
};
